import http from '../shared/HttpCommon';
import { Dispatch, SetStateAction } from 'react';

const analyzeMonitoring = async (
  monitoringId: string,
  loading: Dispatch<SetStateAction<boolean>>
) => {
  try {
    loading(true);
    const { data } = await http.get('/review-ai/' + monitoringId + '/analyze');
    loading(false);
    return data;
  } catch (error) {
    loading(false);
    console.error(error);
  }
};

const ReviewAiService = {
  analyzeMonitoring,
};

export default ReviewAiService;
